/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Parallax } from 'react-parallax';

import Logo from './svg/Logo';
import Fb from './svg/Fb';
import Twitter from './svg/Twitter';
import LinkedIn from './svg/LinkedIn';

const sectionCss = css`
  padding: 12em 10px;
  color: #fff;
`;

const wrapperCss = css`
  max-width: 700px;
  margin: 0 auto;
`;

const socialCss = css`
  display: flex;
  margin-top: 20px;
  > a {
    display: flex;
    width: 26px;
    height: 26px;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.65);
    opacity: 0.4;
    transition: all 350ms ease;
    & + a {
      margin-left: 8px;
    }

    @media (hover: hover) {
      &:hover {
        opacity: 1;
      }
    }
  }
`;

const facebookCss = css`
  @media (hover: hover) {
    &:hover {
      background-color: #3b5998;
    }
  }
`;

const twitterCss = css`
  @media (hover: hover) {
    &:hover {
      background-color: #4099ff;
    }
  }
`;

const linkedInCss = css`
  @media (hover: hover) {
    &:hover {
      background-color: #01476d;
    }
  }
`;

const Contact = ({
  bg,
  companyName,
  companyActivity,
  address,
  zipcode,
  city,
  phone,
  email,
  facebook,
  twitter,
  linkedin,
}) => {
  return (
    <Parallax
      bgImage={bg.fluid.src}
      strength={500}
      style={{ backgroundColor: '#000' }}
    >
      <section name="contact" css={sectionCss}>
        <div css={wrapperCss}>
          <div itemScope itemType="http://schema.org/Organization">
            <Logo width={100} height={94} />
            <h4 itemProp="name">{companyName}</h4>
            <h5
              itemProp="makesOffer"
              itemScope
              itemType="http://schema.org/Offer"
            >
              <span itemProp="category">{companyActivity}</span>
            </h5>
          </div>
          <div
            itemProp="address"
            itemScope
            itemType="http://schema.org/PostalAddress"
          >
            <p itemProp="streetAddress">{address}</p>
            <p>
              <span itemProp="postalCode">{zipcode}</span>&nbsp;
              <span itemProp="addressLocality">{city}</span>
            </p>
          </div>
          <div>
            <p itemProp="telephone">{phone}</p>
            <address>
              <a href={`mailto:${email}`} itemProp="email">
                {email}
              </a>
            </address>
          </div>
          <div css={socialCss}>
            <a
              css={facebookCss}
              href={facebook}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Fb />
            </a>
            <a
              css={twitterCss}
              href={twitter}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Twitter />
            </a>
            <a
              css={linkedInCss}
              href={linkedin}
              rel="noopener noreferrer"
              target="_blank"
            >
              <LinkedIn />
            </a>
          </div>
        </div>
      </section>
    </Parallax>
  );
};

export default Contact;
